import React from 'react'
import Sketch from 'react-p5'

import Matter from "matter-js"

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"left",
        description:""
    },
    de: {
        title:"links",
        description:""
    }
});

class Left extends React.Component {
    constructor(props) {
        super(props)

        this.engine = null
        this.world = null
        this.fontSize = 10
        this.frameCounter = 0

        this.minNextWordFrame = 60
        this.maxNextWordFrame = 120

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.background(0)

        this.engine = Matter.Engine.create()
        this.world = this.engine.world
        this.world.gravity = {x: 1, y:0}

        this.frameCounter = 0

        this.world.gravity.scale = 0.0001

        this.fontSize = Math.floor(window.innerHeight / 20)

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        Matter.World.add(this.world, extensions.makeWalls(p5, true, true, true, true))
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.reset(p5)
    }

    newWord(p5, x, y) {
        var chars = []
        var xoffs = 0
        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)
        for (const c of strings.title) {
            var th = extensions.textHeight(p5.drawingContext, c)
            chars.push(extensions.makePhysicsCharacter(p5, x+xoffs, y-th/2, c, this.fontSize))
            xoffs += p5.textWidth(c)*1.1
        }

        Matter.World.add(this.world, chars)
    }

    draw(p5) {
        p5.background(0)
        if (this.world !== undefined) {
            Matter.Engine.update(this.engine);

            if (this.frameCounter <= 0) {
                this.frameCounter = p5.random(this.minNextWordFrame, this.maxNextWordFrame)
                this.newWord(p5, p5.width/5, p5.random(0, p5.height))
            }
            else {
                this.frameCounter--
            }

            var bodies = Matter.Composite.allBodies(this.engine.world);

            for (var i = 0; i < bodies.length; i += 1) {
                var body = bodies[i]

                extensions.drawPhysicsCharacter(p5, body)
            }
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Left.contextType = LanguageContext

export default Left
